const isMiniChartWebView = window.location.pathname.includes('/minichart-webview');

if (isMiniChartWebView) {
  import(/* webpackChunkName: "miniChartEntry" */ './miniChartWebViewEntry');
} else {
  import(/* webpackChunkName: "appEntry" */ './appEntry');
}

// Make this file a module (TS `isolatedModules`); only dynamic imports above.
export {};
